import { List } from 'react-bootstrap-icons';
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';

export const ListItemsButton = (props: { warehouseId: string }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/inventory?warehouseId=${props.warehouseId}`);
  };

  return (
    <OverlayTrigger overlay={<Tooltip>View Items</Tooltip>}>
      <Button
        variant="outline-primary"
        size="sm"
        onClick={handleClick}>
        <List />
      </Button>
    </OverlayTrigger>
  );
};